import "./App.scss";

import { BrowserAuthorizationClient } from "@itwin/browser-authorization";
import { FillCentered } from "@itwin/core-react";
import { ProgressLinear } from "@itwin/itwinui-react";

import { useAccessToken } from "@itwin/web-viewer-react";
import React, { useCallback, useEffect, useMemo, useState } from "react";

import { history } from "./history";
import { SurplusmapViewer } from "./Viewer/SurplusMapViewer";
import { FrontstageManager } from "@itwin/appui-react";
// import { readGltfGraphics } from "@itwin/core-frontend";
// import { Decorator } from "@itwin/core-frontend";
// import { RenderGraphic } from "@itwin/core-frontend";
// import { Id64String } from "@itwin/core-bentley";
// import { DecorateContext } from "@itwin/core-frontend";
// import { GraphicType } from "@itwin/core-frontend";
// import { IModelConnection } from "@itwin/core-frontend";
// import { Transform } from "@itwin/core-geometry";
// import { GraphicBranch } from "@itwin/core-frontend";
// import { IModelApp } from "@itwin/core-frontend";
// import { Point3d } from "@itwin/core-geometry";
// import { Range3d } from "@itwin/core-geometry";
// import { BingLocationProvider } from "@itwin/core-frontend";
// import Haversine from "./Helpers/Haversine";
import { MapApi } from "./Maps/MapApi";

const App: React.FC = () => {
  const [iModelId, setIModelId] = useState(process.env.IMJS_IMODEL_ID);
  const [iTwinId, setITwinId] = useState(process.env.IMJS_ITWIN_ID);
  const accessToken = useAccessToken();
  // const [longtitude, setLongtitude] = useState<string | null>();
  // const [lattitude, setLattitude] = useState<string | null>();
  // const [constructionType, setConstructionType] = useState<string | null>();

  //  setLongtitude(queryParameters.get("lon"));
  //  setLattitude(queryParameters.get("lat"));
  //  setConstructionType(queryParameters.get("type"));

  const queryParameters = new URLSearchParams(window.location.search);
  if (queryParameters.get("location"))
    MapApi.destination = queryParameters.get("location") as string;

  const authClient = useMemo(
    () =>
      new BrowserAuthorizationClient({
        scope: process.env.IMJS_AUTH_CLIENT_SCOPES ?? "",
        clientId: process.env.IMJS_AUTH_CLIENT_CLIENT_ID ?? "",
        redirectUri: process.env.IMJS_AUTH_CLIENT_REDIRECT_URI ?? "",
        postSignoutRedirectUri: process.env.IMJS_AUTH_CLIENT_LOGOUT_URI,
        responseType: "code",
        authority: process.env.IMJS_AUTH_AUTHORITY,
      }),
    []
  );

  const login = useCallback(async () => {
    try {
      await authClient.signInSilent();
    } catch {
      await authClient.signIn();
    }
  }, [authClient]);

  useEffect(() => {
    void login();
  }, [login]);

  useEffect(() => {
    if (accessToken) {
      const urlParams = new URLSearchParams(window.location.search);
      if (urlParams.has("iTwinId")) {
        setITwinId(urlParams.get("iTwinId") as string);
      } else {
        if (!process.env.IMJS_ITWIN_ID) {
          throw new Error(
            "Please add a valid iTwin ID in the .env file and restart the application or add it to the iTwinId query parameter in the url and refresh the page. See the README for more information."
          );
        }
      }

      if (urlParams.has("iModelId")) {
        setIModelId(urlParams.get("iModelId") as string);
      }
    }
  }, [accessToken]);

  useEffect(() => {
    if (accessToken && iTwinId) {
      let queryString = `?iTwinId=${iTwinId}`;
      if (iModelId) {
        queryString += `&iModelId=${iModelId}`;
      }

      history.push(queryString);
    }
  }, [accessToken, iTwinId, iModelId]);

  FrontstageManager.onFrontstageReadyEvent.addListener((event) => {
    // Functionality that needs to load after everything is ready, eg. to prevent race conditions, can be pasted here
  });

  // lon=3;lat=3;type=charger

  /* const onIModelConnected = async (iModel: IModelConnection) => {
        const elementOfInterestdecorator = new GltfDecoration(
            elements,
            await markerImagePromise,
            iModel
        );
        IModelApp.viewManager.addDecorator(elementOfInterestdecorator);
    }
    */

  return (
    <div className="viewer-container">
      {!accessToken && (
        <FillCentered>
          <div className="signin-content">
            <ProgressLinear indeterminate={true} labels={["Signing in..."]} />
          </div>
        </FillCentered>
      )}
      <SurplusmapViewer
        iTwinId={iTwinId ?? ""}
        iModelId={iModelId ?? ""}
        authClient={authClient}
      />
    </div>
  );
};

export default App;
